module.exports = __webpack_public_path__ + "static/sport/logo.3c3488b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/logo.png
// module id = nMry
// module chunks = 0